<div mat-dialog-title class="header">
    <h2>Distribuir Créditos - Plano {{data.plano?.nome}}</h2>
    <div style="text-align: right;">
        <div class="points">
            <i class="fas fa-star"></i>
            <span>Créditos: {{data.plano?.limiteOfertas}}</span>
        </div>
        <div class="points">
            <span [style.color]="countCreditos() < 0 ? '#eb2336' : '#A6A6A6'">Saldo: {{countCreditos()}}</span>
        </div>
    </div>
</div>
<mat-dialog-content>
    <form #form="ngForm" (ngSubmit)="onClose(form, true)">
        <div class="item" *ngFor="let u of usuarios; let i = index;">
            <label class="item__name" [for]="'limiteOfertas'+i">{{u.nome}}</label>
            <input type="tel" [id]="'limiteOfertas'+i" [name]="'limiteOfertas'+i" [(ngModel)]="u.limiteOfertas"
                mask="0*" required>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button cdkFocusInitial (click)="onClose(form, false)" type="button">Cancelar</button>
    <button mat-stroked-button color="primary" (click)="onClose(form, true)">Salvar</button>
</mat-dialog-actions>